import {ChangeEventHandler, FC} from 'react';
import {RadioButtonWrapper} from './RadioButton.styles';

interface RadioButtonProps {
  name?: string;
  id: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  checked?: boolean;
  label: React.ReactNode;
  value: string;
  disabled?: boolean;
  invertedColors?: boolean;
}

const RadioButton: FC<RadioButtonProps> = ({
  name,
  id,
  onChange,
  checked,
  label,
  value,
  disabled,
}) => {
  return (
    <RadioButtonWrapper htmlFor={id} active={checked}>
      {
        <input
          type="radio"
          id={id}
          name={name}
          onChange={onChange}
          value={value}
          checked={checked}
          disabled={disabled}
        />
      }
      {label && <label htmlFor={id}>{label}</label>}
    </RadioButtonWrapper>
  );
};

export default RadioButton;
